var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpiredLink = function SvgExpiredLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 59"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B9BBC6",
    strokeDasharray: "6 6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M.625 52.258V.76h94.5v51.498l-39.5-24-8 5.5-8-5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B9BBC6",
    strokeDasharray: "6 6",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    d: "M.625.76h94.5l-47.5 32.998z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BBB",
    strokeDasharray: "6 6",
    d: "M95.625 52.758H.125"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.875 35h24v24h-24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D63",
    fillRule: "evenodd",
    d: "M85.168 40.293a1 1 0 0 1 1.414 0l5.293 5.293 5.293-5.293a1 1 0 0 1 1.414 1.414L93.29 47l5.293 5.293a1 1 0 0 1-1.414 1.414l-5.293-5.293-5.293 5.293a1 1 0 0 1-1.414-1.414L90.46 47l-5.293-5.293a1 1 0 0 1 0-1.414Z",
    clipRule: "evenodd"
  })));
};
export default SvgExpiredLink;